import React, { FC } from 'react';
import Svg from 'svg-inline-react';
import classnames from 'classnames';
import MeetFrankSvg from '@src/svgs/meet-frank-logo-dark.svg';
import { Container } from '@src/components/Container';
import { AuthWrapperProps } from './props';
import './styles.scss';

export const AuthWrapper: FC<AuthWrapperProps> = ({ children, wrapperClassName }) => {
  return (
    <div className={classnames('auth-wrapper', wrapperClassName)}>
      <div className="auth-wrapper__container">
        <Svg className="auth-wrapper__meetfrank" src={MeetFrankSvg} />
        <h3 className="auth-wrapper__message">Welcome!</h3>
        <Container className="auth-wrapper__content-container" type="bordered-with-shadow">
          {children}
        </Container>
      </div>
    </div>
  );
};
